import { RealEstateComplexMessage as RealEstateComplexMessageResponse } from "../../api/HomePageResponseTypes";
import { DateString } from "../../util/conversionUtils";

export interface RealEstateMessage extends Omit<RealEstateComplexMessageResponse, "saadetud" | "vastatud"> {
  saadetud: DateString;
  vastatud: DateString;
}

export enum ColumnHeader {
  complexCode = "complexCode",
  sent = "sent",
  content = "content",
  comment = "comment",
  replied = "replied",
  reply = "reply",
}
